<template lang="html">
  <div class="model-points-desc">
    <div class="box">
      <header></header>
      <div class="inner">
        <div class="title">畅由积分说明</div>
        <div class="subtitle">畅由积分由通用积分、营销积分及APP奖励积分组成；</div>

        <ul>
          <li>
            <header>通用积分</header>
            <div>通过移动、中行、东航等渠道兑入的畅由积分，以及通过积分加油站购买的畅由积分；</div>
          </li>
          <li>
            <header>营销积分</header>
            <div>通过特定营销活动获赠的畅由积分</div>
          </li>
          <li>
            <header>App奖励积分</header>
            <div>{{ data.advertiseIntroduce }}</div>
          </li>
        </ul>
      </div>
      <footer><div @click="onSubmit">我知道了</div></footer>
    </div>
  </div>
</template>

<script>
import { reqCyQueryAdvert } from 'changyo-public-api'

export default {
  name: 'ModelPointsDesc',

  props: {
    onSubmit: {
      type: Function,
      default: () => null
    }
  },

  data() {
    return {
      data: {}
    }
  },

  mounted() {
    this.getData()
  },

  methods: {
    async getData() {
      const param = {
        appId: 'Changyoyo_Life_Central',
        featuredFirstCode: 'H5_110_good4',
        channel: 'Changyoyo_Life_Central',
        pageNum: 1,
        pageSize: 10
      }

      const res = await reqCyQueryAdvert(param).catch(err => console.log(err))

      if (res && res.data && res.data.advertiseOnlines && res.data.advertiseOnlines.length > 0) {
        this.data = res.data.advertiseOnlines[0]
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.model-points-desc
  position fixed
  top 0
  left 0
  z-index 999
  width 100%
  height 100%
  display flex
  align-items center
  background-color rgba(0, 0, 0, .5)

  & > .box
    width (333 * 2 / 100)rem
    margin 0 auto
    background-color #fff
    border-radius .16rem

    & > header
      height (132 * 2 / 100)rem
      background-image url('./images/bg-header.png')
      background-size cover
      background-position center

    & > footer
      padding-bottom .56rem

      & > div
        height 1rem
        line-height @height
        margin 0 .4rem
        background-image linear-gradient(to right, #e9cc8a, #dfb27c)
        border-radius 1rem
        font-size .32rem
        font-weight bold
        color #50462d
        text-align center

    & > .inner
      padding 0 .4rem
      & > .title
        margin-top -.8rem
        font-size .48rem
        font-weight bold
        color #000

      & > .subtitle
        margin-top .24rem
        color #666
        font-size .24rem

      & > ul
        margin-top .8rem

        & > li
          margin-bottom .36rem
          line-height normal

          & > header
            position relative
            margin-bottom .1rem
            padding-left .2rem
            font-size .28rem
            font-weight bold
            color #4a4a4a
            vertical-align middle

            &:before
              position absolute
              top 50%
              left 0
              content ''
              width .08rem
              height @width
              margin-top -(@width / 2)
              background-color #7a5c3e
              border-radius 50%

          & > div
            font-size .24rem
            color #9b9b9b
</style>
